const TEXT_KEY_BY_ERROR_CODE: Record<string, string> = {
  AREA_TOO_LARGE: 'site_data_badge_whisp_too_large_tr',
  TOO_LARGE_AREA: 'site_data_badge_whisp_too_large_tr',
  INVALID_GEOMETRY: 'site_data_badge_whisp_invalid_geometry_tr',
  RETRIES_EXHAUSTED: 'site_data_badge_whisp_retries_exhausted_tr',
};

export function whispErrorTextKey(errorCode: string | null | undefined): string | null {
  return TEXT_KEY_BY_ERROR_CODE[errorCode ?? ''] ?? null;
}

export function whispFindingErrorKey(
  view: { status: string; errorCode?: string | null } | null | undefined
): string | null {
  if (view?.status !== 'ERROR' || !view.errorCode) return null;
  return whispErrorTextKey(view.errorCode) ?? 'whisp_error_code_tr';
}
